import Image from 'components/Shared/Image';
import styles from './styles.scss';
import cn from 'classnames';
import onTvBadge from 'assets/img/staticimages/tv.png';

interface OwnProps {
  className?: string;
}

const ON_TV_BADGE_SIDE_LENGTH = 84;

export default ({ className }: OwnProps) => (
  <Image
    src={onTvBadge}
    width={ON_TV_BADGE_SIDE_LENGTH}
    height={ON_TV_BADGE_SIDE_LENGTH}
    className={cn(styles.base, className)}
  />
);
